/**
 * Maintained by Sandon.
 */
<template>
  <div class="process">
    <div class="header font-color-primary">
      <div class="header-label"><span>{{pageText.processTitle}}</span></div>
      <div @click="closeFun" class="el-icon-close closeBtn"></div>
    </div>
    <!-- <div class="tip" v-if="processList.length > 0">
      <tip-box>
        <span class="tip-msg">操作记录系统最多保留30天，操作完成后可下载结果。</span>
      </tip-box>
    </div> -->
    <ul class="list" v-if="processList.length > 0">
      <li class="syue-clr" v-for="item of processList" :key="item.id">
        <div class="name-time syue-left">
          <SyForm styleType='mini'>
            <SyFormItem :hideLabel="true" :removeLabel="true">
              <p class="name">
                {{item.name || ''}}
              </p>
            </SyFormItem>
            <SyFormItem :hideLabel="true" :removeLabel="true">
              <p class="time">
                {{moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')}}
              </p>
            </SyFormItem>
          </SyForm>
        </div>
        <div class="status syue-left">
          <SyForm styleType='mini'>
            <SyFormItem :hideLabel="true" :removeLabel="true">
              <p>
                <span class="status-icon">
                  <i v-if="item.state == 1" class="el-icon-loading"></i>
                  <i v-if="item.state == 2 && item.desc && (item.type === 1 || item.type === 3)" class="el-icon-warning warning"></i>
                  <i v-else-if="item.state == 2" class="el-icon-success green"></i>
                  <i v-if="item.state == 3" class="el-icon-error highlight"></i>
                  <i v-if="item.state == 4" class="el-icon-error highlight"></i>
                </span>

                <!--:class="[item.state == 1
                ? 'normal'
                : item.state == 2
                ? item.desc && (item.type === 1 || item.type === 3)
                ? 'warning' : 'green'
                : item.state == 3 || item.state == 4
                ? 'highlight'
                : '']"-->
                <span
                  class="status-msg">
                  {{item.state == 2 && item.desc && (item.type === 1 || item.type === 3) ? pageText.warning : state[item.state]}}
                </span>
                <!--<el-tooltip v-if="item.state == 3" effect="dark" :content="item.desc" placement="top">-->
                <!--  <i class="err-msg iconfont icon-shuoming"></i>-->
                <!--</el-tooltip>-->
                <!--<span v-if="item.desc">{{item.desc}}</span>-->
              </p>
            </SyFormItem>
            <SyFormItem :hideLabel="true" :removeLabel="true">
              <p class="success-msg" v-if="item.desc && item.desc.length <= 10">{{item.desc}}</p>
              <el-tooltip effect="dark" v-if="item.desc && item.desc.length > 10" :content="item.desc" placement="top">
                <p class="success-msg">{{item.desc}}</p>
              </el-tooltip>
            </SyFormItem>
          </SyForm>

        </div>
        <div class="actions syue-left">
          <!--完成-->
          <template v-if="item.state == '2'">
            <!--异步导出：下载 -->
            <Buttons type="link" v-if="item.type == 2" @click.prevent="download(item)">{{pageText.download}}</Buttons>
            <!-- 中转任务 -->
            <Buttons type="link" v-else-if="item.type === 4 && item.transferUrl" class="font-color-link" @click.prevent="processRouter(item)">{{pageText.lookup}}</Buttons>
            <!-- 异步导入/异步任务：问题数据下载 -->
            <el-tooltip v-else-if="item.desc" effect="dark" :content="pageText.downloadContent" placement="top">
              <Buttons type="link" @click.prevent="download(item)">{{pageText.download}}</Buttons>
            </el-tooltip>
          </template>
          <!--失败-->
          <Buttons type="link" v-else-if="item.state == '3'" @click.prevent="del(item.id)">{{pageText.del}}</Buttons>
        </div>
      </li>
    </ul>
    <div class="process-footer__wrap" v-if="processList.length > 0">
      <Buttons type="link" @click.prevent="goAllList">{{pageText.allView}}</Buttons>
    </div>
    <div class="notMessage" v-if="processList.length === 0">
      {{pageText.noData}}
    </div>
  </div>

</template>

<script>
  import moment from 'moment'
  import TipBox from '../../../components/basis/tip-box/tip-box.vue'
  import processApi from './api'
  import getResponse from '../../../utils/response'
  import download from '../../../utils/download'
  import i18n from './i18n.js'
  import { SyForm, SyFormItem, Buttons } from './../../../index.js'
  const pageText = window.fe.getPageText(i18n)

  const SYSTEM_TYPE = {
    'purchaser': 'purchaser_web',
    'supplier': 'supplier_web',
    'mall': 'mall_web'
  }

  export default {
    name: 'process',
    components: {
      TipBox,
      SyForm,
      SyFormItem,
      Buttons
    },
    props: {
      limit: {
        type: Number,
        default: 0
      }
      // system: {
      //   type: String,
      //   default: 'purchaser_web'
      // }
    },
    data () {
      return {
        window: window,
        pageText,
        moment,
        processList: [],
        // 状态集成
        state: {
          0: pageText.all,
          1: pageText.execution,
          2: pageText.completed,
          3: pageText.executionFailed,
          4: pageText.taskTimeout
        }
        // type: {
        //   0: '全部',
        //   1: '异步导入',
        //   2: '异步导出'
        // }
      }
    },
    created () {
      // this.fetchData()
    },
    computed: {
      system () {
        return SYSTEM_TYPE[window.fe.project] || 'purchaser_web'
      }
    },
    methods: {
      closeFun () {
        this.$emit('closePopover')
      },
      // 查看全部进程
      goAllList () {
        this.$emit('closePopover')
        this.$routerPush({
          path: '/process/list',
          query: {
            beforeUrl: this.$route.path
          },
          type: 'blank'
        })
      },
      // 获取临时令牌
      async getToken () {
        const api = processApi.getToken
        const params = {
          clientType: this.system
        }
        await getResponse(this.$http(api.type, api.url, params))
      },
      // 获取进程列表
      async fetchData () {
        if (this.timer) this.clearTime()
        await this.getToken()
        let _this = this
        const api = processApi.prcessList
        const param = {
          page: 1,
          pageSize: 5,
          system: this.system
          // userinfo: token
        }
        const data = await getResponse(_this.$http(api.type, api.url, param))
        // _this.processList = [..._this.processList]
        if (data.isOk) {
          const processList = data.content || []
          _this.processList = this.limit ? processList.slice(0, this.limit) : processList
          const aFinishes = _this.processList.filter(item => item.state !== 2 && item.state !== 3)
          if (aFinishes && aFinishes.length) {
            this.timer = setTimeout(() => {
              _this.fetchData()
            }, 10000)
          }
        } else {
          this.clearTime()
        }
      },
      // 停止轮询
      clearTime () {
        clearTimeout(this.timer)
      },
      cancel () {

      },
      del (row) {
        this.$confirm(this.pageText.delConfirm, this.pageText.tip).then(() => {
          this._del(row)
        })
      },
      async _del (id) {
        await this.getToken()
        const api = processApi.processDlelte
        const param = {
          id: id,
          system: this.system
          // userinfo: token
        }
        const data = await getResponse(this.$http(api.type, api.url, param), {
          loadingOptions: true
        })
        // this.processList = [...this.processList]
        if (data.isOk) {
          this.$message.success(this.pageText.delSuccess)
          this.fetchData()
        }
      },
      async download (item) {
        await this.getToken()
        const api = processApi.downloadData
        const params = Object.assign({}, {
          id: item.id,
          attachedUrl: item.attachedUrl,
          system: this.system
          // userinfo: token
        })
        // const data = await getResponse(this.$http(api.type, api.url, params), {
        //   loadingOptions: true
        // })
        // if (data.isOk) {
        //   console.log(data)
        // }
        download('get', api.url, params)
      },
      processRouter (row) {
        const isIE = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
        window.location.href = `//${window.fe.baseUrl}${row.transferUrl}`.replace(/(\/*)/, '//')
        // 兼容IE不跳转
        if (isIE) {
          window.location.reload()
        }
      }
    },
    deprecated () {
      this.clearTime()
    }
  }
</script>

<style scoped lang="scss">
  .process{
    font-size: 12px;
  }
  .header{
    height: 40px;
    line-height: 40px;
    padding-left: 15px;
    margin-bottom: 6px;
    border-bottom: 1px solid #ECEDEE;
    font-weight: bold;
    .header-label{
      display: inline-block;
      padding-left: 5px;
      border-left: 3px solid currentColor;
      height: 14px;
      line-height: 14px;
      span{
        color: #333;
        font-size: 14px;
      }
    }
    .closeBtn {
      float: right;
      cursor: pointer;
      color: #909399;
      font-size: 16px;
      height: 40px;
      line-height: 40px;
      margin-right: 20px;
    }
  }
  .tip{
    padding: 0 10px;
  }
  .tip-msg{
    line-height: 20px;
  }
  .process-footer__wrap{
    line-height: 36px;
    text-align: center;
    font-size: 12px;
    color: #333333;
    a{
      color: #666;
    }
  }
  .list li{
    // height: 55px;
    border-bottom: 1px solid #ECEDEE;
    color: #333;
  }
  .name-time{
    width: 200px;
    padding: 10px 0 10px 20px;
    line-height: 17px;
  }
  .name{
    overflow: hidden;
    height: 14px;
    padding-right: 10px;
    white-space:nowrap;
    text-overflow: ellipsis;

    i{
      display: inline-block;
      opacity: 0;
      width: 14px;
      height: 14px;
      text-align: center;
      line-height: 14px;
      margin-right: 6px;
      &.icon {
        opacity: 1;
        color: #fff;
        background: #6A87A8;
        border-radius: 7px;
      }
    }
  }
  .notMessage {
    text-align: center;
    line-height: 60px;
    font-size: 12px;
    color: #999;
  }
  .time{
    //padding-left: 20px;
    color: #999;
  }
  .status{
    padding-top: 10px;
    width: 140px;
    line-height: 17px;
  }
  .status-icon{
    display: inline-block;
    // width: 36px;
    text-align: right;
    font-size: 16px;
    vertical-align: top;
  }
  .success-msg{
    width: 100%;
    color: #999;
    overflow: hidden;
    height: 14px;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: pointer;
  }
  .err-msg{
    font-size: 12px;
    color: #666;
  }
  .highlight{
    color: #EB2B2B;
  }
  .actions{
    width: 40px;
    padding: 10px 0 0 10px;
  }
  .green{
    color: #38BB54;
  }
  .grey{
    color: #3F3F3F;
  }
  .warning {
    color: #ff8933;
  }
  a {
    color: #3072F3;
  }
  a:hover {
    color: #3072F3;
  }
  .status-msg {
    color: #333;
  }
</style>
